import { Language } from '@ha/intl';

// paths for chinese pages are commented due to absent translations

export const globalReach = {
  [Language.en]: '/global-audience-reach',
  [Language.fr]: '/audience-mondiale',
  [Language.de]: '/weltweite-reichweite',
  [Language.es]: '/visibilidad-global',
  [Language.it]: '/visibilita-globale',
  [Language.nl]: '/wereldwijd-publiek-globaal-bereik',
  [Language.pt]: '/alcance-do-publico-mundial',
  // [Language.zh]: '/覆盖全球观众',
  [Language.zh]: '/global-audience-reach',
  [Language.uk]: '/залучення-аудиторії',
  [Language.ru]: '/глобальный-охват-аудитории',
  [Language.pl]: '/globalny-zasieg-odbiorcow',
  [Language.sv]: '/global-publik-rackvidd',
  [Language.ro]: '/atingerea-audientei-globale',
};

export const easyPropertyManagement = {
  [Language.en]: '/easy-property-management',
  [Language.fr]: '/gestion-immobiliere-simplifiee',
  [Language.de]: '/einfache-immobilienverwaltung',
  [Language.es]: '/gestiona-tus-propiedades-facilmente',
  [Language.it]: '/gestisci-facilmente-le-tue-proprietà',
  [Language.nl]: '/eenvoudig-woonruimte-adverteren',
  [Language.pt]: '/gestao-facil-da-propriedade',
  // [Language.zh]: '/简易物业管理',
  [Language.zh]: '/easy-property-management',
  [Language.uk]: '/просте-управління-житлом',
  [Language.ru]: '/простое-управление-недвижимостью',
  [Language.pl]: '/latwe-zarzadzanie-nieruchomosciami',
  [Language.sv]: '/enkel-fastighetsforvaltning',
  [Language.ro]: '/gestionarea-usoara-a-proprietatii',
};

export const integrations = {
  [Language.en]: '/integrations',
  [Language.fr]: '/integrations',
  [Language.de]: '/integrationen',
  [Language.es]: '/integraciones',
  [Language.it]: '/integrazioni',
  [Language.nl]: '/api-integratie',
  [Language.pt]: '/integracoes',
  // [Language.zh]: '/集成',
  [Language.zh]: '/integrations',
  [Language.uk]: '/інтеграції',
  [Language.ru]: '/интеграции',
  [Language.pl]: '/integracje',
  [Language.sv]: '/integrationer',
  [Language.ro]: '/integrari',
};

export const securePayments = {
  [Language.en]: '/secure-payments',
  [Language.fr]: '/paiements-securise',
  [Language.de]: '/sichere-bezahlung',
  [Language.es]: '/pagos-seguros',
  [Language.it]: '/pagamenti-sicuri',
  [Language.nl]: '/veilige-huurbetalingen',
  [Language.pt]: '/pagamentos-seguros',
  // [Language.zh]: '/安全支付',
  [Language.zh]: '/secure-payments',
  [Language.uk]: '/безпечні-платежі',
  [Language.ru]: '/безопасные-платежи',
  [Language.pl]: '/bezpieczne-platnosci',
  [Language.sv]: '/sakra-betalningar',
  [Language.ro]: '/plati-sigure',
};

export const superiorMatching = {
  [Language.en]: '/superior-matching',
  [Language.fr]: '/trouvez-le-locataire-ideal',
  [Language.de]: '/der-perfekte-mieter',
  [Language.es]: '/encuentra-al-inquilino-perfecto',
  [Language.it]: '/trova-l-inquilino-ideale',
  [Language.nl]: '/de-beste-match-voor-jou',
  [Language.pt]: '/match-de-inquilinos',
  // [Language.zh]: '/优越的匹配',
  [Language.zh]: '/superior-matching',
  [Language.uk]: '/точний-підбір',
  [Language.ru]: '/точный-подбор',
  [Language.pl]: '/idealne-dopasowanie',
  [Language.sv]: '/overlagsen-matchning',
  [Language.ro]: '/potrivire-superioara',
};
